import {isParticipantActive as statusFlagsIsParticipantActive} from './status_flags/isParticipantActive';

/**
 * Checks if the given participant is active.
 *
 * @param {object} participant - The participant object to check.
 * @return {boolean} Returns true if the participant is active, false otherwise.
 */
export function isParticipantActive(participant) {
    if (participant?.status_flags) {
        return statusFlagsIsParticipantActive(participant);
    }

    return !!participant?.user_id;
}
